module.exports = __webpack_public_path__ + "bv.19acce5fe4d41cc8d9d2.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/bv.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/bv.svg
// module chunks = styles